import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function ModalClear({ isClearing, onClearClose, clearTasks }) {
  const { t } = useTranslation()

  return (
    <Modal show={isClearing} onHide={onClearClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('event.clear_task_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('event.clear_task_message')}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClearClose}>
          {t('buttons.cancel')}
        </Button>
        <Button variant="danger" onClick={clearTasks}>
          {t('buttons.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
